import { render, staticRenderFns } from "./PaginatedFileList.vue?vue&type=template&id=61e32fcd&scoped=true&"
import script from "./PaginatedFileList.vue?vue&type=script&lang=js&"
export * from "./PaginatedFileList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e32fcd",
  null
  
)

export default component.exports